<script setup>
import Navbar from '@/layouts/components/Navbar/Navbar.vue';

</script>

<template>
    <!--**********************************
        Main wrapper start
    ***********************************-->
    <div id="main-wrapper">
        <Navbar />
        <!--**********************************
            Content body start
        ***********************************-->
        <div class="content-body highlight">
            <slot name="main">
            </slot>
        </div>
        <!--**********************************
            Content body end
        ***********************************-->
    </div>
    <!--**********************************
        Main wrapper end
    ***********************************-->

</template>

<style>
 .heightPrincipalCardHc {
  height: calc(100lvh - 75px) !important;
}

#main-wrapper {
    display: flex;
}

.content-body {
    position: relative;
    min-height: calc(100vh - 40px);
    width: 100%;
    overflow: hidden;
    transition: all 0.35s ease-in-out;
    margin-top: 40px !important;
    margin-left: 0px !important;
    padding: 20px 15px;
}

.media-object {
    height: 50px;
}

.fixed {
    width: 55px;
} 
</style>
